var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.05C3 7.57467 3.42533 8 3.95 8H20.05C20.5747 8 21 7.57467 21 7.05V6.95C21 6.42533 20.5747 6 20.05 6H3.95C3.42533 6 3 6.42533 3 6.95V7.05ZM3.95 13C3.42533 13 3 12.5747 3 12.05V11.95C3 11.4253 3.42533 11 3.95 11H20.05C20.5747 11 21 11.4253 21 11.95V12.05C21 12.5747 20.5747 13 20.05 13H3.95ZM3.95 18C3.42533 18 3 17.5747 3 17.05V16.95C3 16.4253 3.42533 16 3.95 16H20.05C20.5747 16 21 16.4253 21 16.95V17.05C21 17.5747 20.5747 18 20.05 18H3.95Z",
    fill: "#0473EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e637f3e28229f54e31df34de84a8ffd7.svg";
export { ForwardRef as ReactComponent };